'use client';

import React from 'react';

interface IconSelectorProps {
	right: boolean;
	height: string;
}

const LogoDecorationMotif: React.FC<IconSelectorProps> = ({ right = true, height }) => {
	const iconSrc = right 
		? '/Logo-Decoration-Motif-Right-Desktop.svg' 
		: '/Logo-Decoration-Motif-Left-Desktop.svg';

	return (
		<img 
			src={iconSrc} 
			alt="Logo Decoration Motif" 
			style={{ height }}
			className='w-auto' 
		/>
	);
};

export default LogoDecorationMotif;
